import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/certificate-green.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e468d27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col bg-white shadow-md p-4 my-2 rounded-lg" }
const _hoisted_2 = { class: "flex justify-between items-center pb-4 border-b md:flex-row md:justify-between md:items-center" }
const _hoisted_3 = { class: "text-xs font-bold text-left text-gris80 md:text-sm" }
const _hoisted_4 = { class: "font-normal" }
const _hoisted_5 = { class: "flex justify-between items-center md:flex-row md:justify-between md:items-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "inline-flex",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden md:inline-block" }, "Generar certificado", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "flex items-center justify-center" }
const _hoisted_11 = { class: "text-xs inline-block font-bold text-primary md:text-sm" }
const _hoisted_12 = { class: "py-4 border-b" }
const _hoisted_13 = {
  class: "group outline-none accordion-section",
  tabindex: "1"
}
const _hoisted_14 = { class: "acordeon-header" }
const _hoisted_15 = { class: "group-focus:text-gris80 transition ease duration-500" }
const _hoisted_16 = { class: "flex justify-between items-center" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "text-xs font-bold text-left text-gris80 md:text-sm" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "acordeon-chevron" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19 9l-7 7-7-7"
    })
  ])
], -1))
const _hoisted_20 = { class: "acordeon-body bg-lightSurface-50 rounded mt-2" }
const _hoisted_21 = ["if"]
const _hoisted_22 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_23 = { class: "font-bold text-secondary mb-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-primary text-sm" }, "Comercio:", -1))
const _hoisted_25 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-primary mb-1" }, "N° Crédito", -1))
const _hoisted_27 = { class: "text-sm text-gris120" }
const _hoisted_28 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-primary mb-1" }, "Capital", -1))
const _hoisted_30 = { class: "text-sm text-gris120" }
const _hoisted_31 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-primary font-bold mb-1" }, "Interés", -1))
const _hoisted_33 = { class: "text-sm text-gris120" }
const _hoisted_34 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-primary mb-1" }, "Total Crédito", -1))
const _hoisted_36 = { class: "text-sm text-gris120" }
const _hoisted_37 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-primary mb-1" }, "Estado", -1))
const _hoisted_39 = { class: "text-sm text-gris120" }
const _hoisted_40 = { class: "pt-4" }
const _hoisted_41 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-5 xl:grid-cols-1 2xl:grid-cols-5 3xl:grid-cols-5" }
const _hoisted_42 = { class: "col-span-1" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-left font-bold text-primary" }, "Total deuda", -1))
const _hoisted_44 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"col-span-1\" data-v-5e468d27><p class=\"text-sm text-left font-bold text-primary\" data-v-5e468d27> Fecha de pago </p><p class=\"text-sm text-left font-bold text-gris80\" data-v-5e468d27>Inmediato</p></div><div class=\"col-span-1 justify-between place-items-center lg:flex lg:col-start-3 lg:col-span-3 xl:block xl:flex-none xl:col-span-1 2xl:col-span-3 3xl:flex 3xl:col-span-3\" data-v-5e468d27><span class=\"text-sm font-bold text-gris80 inline-block align-middle mr-4 mb-4 text-center lg:mb-0\" data-v-5e468d27> Tenemos múltiples descuentos que <span class=\"text-sm font-bold text-primary\" data-v-5e468d27>aplican únicamente para este canal</span></span></div>", 2)
const _hoisted_47 = {
  key: 0,
  class: "pt-4"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white font-bold text-xs ml-2 bg-primary px-2 py-1 rounded" }, "Portafolio Judicializado", -1))
const _hoisted_49 = [
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obligationsByPortfolio, (portfolio) => {
    return (_openBlock(), _createElementBlock("div", {
      key: portfolio?.portfolio_id
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(" Fecha de cesión: "),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$filters.formatDate(portfolio?.cesion_date)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "submit",
                class: "obligation-info-certificate-button",
                onClick: ($event: any) => (_ctx.generateCertificate(portfolio))
              }, _hoisted_9, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.statePaymentPlan()), 1),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.bindClassState('activo'))
              }, null, 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("img", {
                    class: "obligations__card-img",
                    src: portfolio?.url_logo,
                    alt: portfolio?.url_logo
                  }, null, 8, _hoisted_17),
                  _createElementVNode("h2", _hoisted_18, _toDisplayString(portfolio?.bank_name), 1)
                ]),
                _hoisted_19
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(portfolio.business, (business) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-col text-left w-full px-0 py-3 md:flex-row",
                  key: business.business_id,
                  if: business.negotiable === 1
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(business?.product), 1),
                    _createElementVNode("p", null, [
                      _hoisted_24,
                      _createTextVNode(" " + _toDisplayString(business?.commerce), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.hiddenPartialData(business?.credit)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$filters.currency(business?.capital_value)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$filters.currency(business?.interests)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$filters.currency(business?.current_debt_value)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("p", _hoisted_39, _toDisplayString(business?.status), 1)
                  ])
                ], 8, _hoisted_21))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$filters.currency(portfolio?.total_portfolio)), 1)
            ]),
            _hoisted_45
          ])
        ]),
        (portfolio?.judicialized_portfolio)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_49))
          : _createCommentVNode("", true)
      ])
    ]))
  }), 128))
}